export default __webpack_public_path__ + "static/media/ZZC_7754.58aafac9.jpg";